





























































































































































































































































































































































import { Component, Vue, Watch } from "vue-property-decorator";
import { RelatorioAssociadosInativosModel } from "@/models/administracao/associados-inativos/RelatorioAssociadosInativosModel";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import ContabilOrcamentoFrotaService from "@/service/ContabilOrcamentoFrotaService";
import GsModalDialog from "@/components/modal/GsModalDialog.vue";
import { tipoServicoList } from "@/models/solicitacoes/TipoServicoModel";
import moment from "moment";
import { orcamentoAutoOnlineService } from "@/service/orcamento-auto-online/OrcamentoAutoOnlineService";
import { ClienteFrotaDTO} from "@/models/orcamento-auto-online/ClienteFrotaModel";
// @ts-ignore
import _ from 'lodash';

@Component({
  components: {
    ValidationObserver,
    ValidationProvider,
    GsModalDialog,
  },
})
export default class RelatorioAssocidosInativos extends Vue {
  $refs!: {
    relatorioObserver: InstanceType<typeof ValidationObserver>;
    pagamentoObserver: InstanceType<typeof ValidationObserver>;  
    faturaObserver: InstanceType<typeof ValidationObserver>;
  };

  clientesFrota: ClienteFrotaDTO[] = [];
  listaTipoServico = tipoServicoList;
  lista = [];
  selected = [];
  disabledCount = 0;
  tableHeader = [
      { text: 'Data', value: 'dataCriacao' , width: '150px'},
      { text: 'Solicitante', value: 'servicoFrota.nomeSubCliente' , width: '250px'},
      { text: 'Veículo', value: 'veiculo.modelo', width: '250px'},
      { text: 'Placa', value: 'veiculo.placa'},
      { text: 'Serviço', value: 'tipoServico' , width: '100px'},
      { text: 'Categoria', value: 'tipoVeiculo', width: '100px'},
      { text: 'Motivo', value: 'motivo', width: '150px'},
      { text: 'KM Total', value: 'distanciaEmKm', width: '100px'},
      { text: 'Nº Solicitação', value: 'numeroServico', width: '150px'},
      { text: 'Valor Total', value: 'preco', width: '130px'},
      { text: 'Emissão', value: 'servicoFrota.dataEmissao'},
      { text: 'Nº da Fatura', value: 'servicoFrota.numeroFatura' , width: '120px'},
      { text: 'Data do Vencimento', value: 'servicoFrota.dataVencimento', width: '160px'},
      { text: 'Data do Pagamento', value: 'servicoFrota.dataPagamento', width: '150px'},
      { text: "Imprimir Fatura", value: "actions", sortable: false }
  ];

  showGerarFatura = false;
  showValidarPagamento = false;
  showDialog = false;
  successDialog = false;
  dialogTitle = "";
  dialogMessage = "";
  loading = false;
  collapsibleOpened = false;

  relatorio: RelatorioAssociadosInativosModel = {
    inicio: undefined,
    fim: undefined,
  };

  fatura = {
    dataPagamento: "",
    dataVencimento: ""
  };

  filtro = {
    dataAte: "", //moment().format("YYYY-MM-DD"),
    dataDe: "", /*moment()
                  .add(-1, "day")
                  .format("YYYY-MM-DD"),*/
    idCliente: null,
    fatura: "",
    tipoServico: null
  };

  filtroInicial = {
    dataAte: "", //moment().format("YYYY-MM-DD"),
    dataDe: "", /*moment()
                    .add(-1, "day")
                    .format("YYYY-MM-DD"),*/
    idCliente: null,
    fatura: "",
    tipoServico: null
  };

  @Watch("filtro.dataAte")
  @Watch("filtro.dataDe")      
  @Watch("filtro.idCliente")
  @Watch("filtro.fatura")
  @Watch("filtro.tipoServico")
  private limparFiltro(): void {
    this.lista = [];
    this.selected = [];
    this.disabledCount = 0;
  }
  
  selectAllToggle(props: any) {
    if(this.selected.length != this.lista.length - this.disabledCount) {
      this.selected = [];
      this.selected = _.filter(props.items, function(item: any) { return (item.servicoFrota.numeroFatura == null); });
    } else {
      this.selected = [];
    }
  }
  
  validarPagamento() {
    this.fatura.dataPagamento = "";
    this.showValidarPagamento = true;
  }

  closeValidarPagamento(accept = false) {
    if (accept) {
      this.$refs.pagamentoObserver.validate()
        .then((valid) => {
          if (valid) {
            let objetoValidarPagamento = {
              dataPagamento: this.fatura.dataPagamento,
              dataInicio: this.filtro.dataDe,
              dataFim: this.filtro.dataAte,
              tipoServico: this.filtro.tipoServico,
              idCliente: this.filtro.idCliente,
              numeroFatura: this.filtro.fatura
            };
            this.loading = true;
            ContabilOrcamentoFrotaService.validarPagamentoFatura(objetoValidarPagamento)
              .then(res => {
                this.loading = false;
                this.showValidarPagamento = false;
                this.lista = res;
                this.disabledCount = _.size(_.filter(this.lista, function(item: any) { return (item.servicoFrota.numeroFatura != null); }));
              })
              .catch((err) => {
                this.openDialog(false, "Erro", err.message);
                this.loading = false;
                this.showValidarPagamento = false;
              });
          }
        })
    } else {
      this.showValidarPagamento = false;
    }
  }

  gerarFatura() {
    if (this.filtro.idCliente == null) {
      this.openDialog(false, 'Filtro inválido', 'Para a geração da fatura preencha o filtro: ‘Cliente’');
      return;
    }

    if (this.selected.length == 0) {
      this.openDialog(false, 'Filtro inválido', 'Selecione os registros para gerar a fatura');
      return;
    }

    this.fatura.dataVencimento = "";
    this.showGerarFatura = true;
  }

  closeGerarFatura(accept = false) {
    if (accept) {
      this.$refs.faturaObserver.validate()
        .then((valid) => {
          if (valid) {
            let objetoGerarFatura = {
              vigenciaInicio: this.filtro.dataDe,
              vigenciaFim: this.filtro.dataAte,
              dataVencimento: this.fatura.dataVencimento,
              faturas: _.map(this.selected, 'id')
            };

            this.loading = true;
            ContabilOrcamentoFrotaService.gerarFatura(objetoGerarFatura)
              .then(res => {
                let fileURL = window.URL.createObjectURL(new Blob([res.data]));
                let fileLink = document.createElement("a");
                fileLink.href = fileURL;
                fileLink.setAttribute(
                  "download",
                  `fatura.${moment().format("YYYYMMDD.HHmm")}.pdf`
                );

                document.body.appendChild(fileLink);
                fileLink.click();

                this.loading = false;
                this.showGerarFatura = false;         
                
                this.realizarConsulta();                  
              })
              .catch((err) => {
                this.openDialog(false, "Erro", err.message);
                this.loading = false;
                this.showGerarFatura = false;
              });
          }
        })
    } else {
      this.showGerarFatura = false;
    }
  }

  imprimirFatura(fatura: any) {
    let idCliente = fatura.idCliente;
    let numeroFatura = fatura.servicoFrota.numeroFatura ;

    this.loading = true;
    ContabilOrcamentoFrotaService.imprimirFatura(idCliente, numeroFatura)
      .then(res => {
        let fileURL = window.URL.createObjectURL(new Blob([res.data]));
        let fileLink = document.createElement("a");
        fileLink.href = fileURL;
        fileLink.setAttribute(
          "download",
          `fatura.${moment().format("YYYYMMDD.HHmm")}.pdf`
        );

        document.body.appendChild(fileLink);
        fileLink.click();

        this.loading = false;
        this.showGerarFatura = false;            
      })
      .catch((err) => {
        this.openDialog(false, "Erro", err.message);
        this.loading = false;
        this.showGerarFatura = false;
      });
  }

  mounted() {
    this.obterClientesFrota();
  }

  obterClientesFrota() {
    this.loading = true;
    this.clientesFrota = [];
    orcamentoAutoOnlineService
      .obterClientesFrota().then((res: ClienteFrotaDTO[]) => {
        this.clientesFrota = res;
        this.loading = false;
      })
      .catch((err) => {
        this.loading = false;
        console.log(err);
      });
  }

  realizarConsulta() {
    if (_.isEqual(this.filtro, this.filtroInicial)) {
      this.openDialog(false, 'Filtro inválido', 'É necessário ao menos um tipo de filtro, revise as informações');
      return;
    }
    this.limparFiltro();

    this.$refs.relatorioObserver.validate().then((valid: boolean) => {
      if (valid) {
        this.loading = true;
        ContabilOrcamentoFrotaService.consultar(this.filtro)
          .then(res => {
            this.loading = false;
            this.lista = res;
            this.disabledCount = _.size(_.filter(this.lista, function(item: any) { return (item.servicoFrota.numeroFatura != null); }));
          })
          .catch((err) => {
            this.openDialog(false, "Erro", err.message);
            this.loading = false;
          });
      }
    });
  }

  public gerarRelatorio(tipo: string): void {

    if (_.isEqual(this.filtro, this.filtroInicial)) {
      this.openDialog(false, 'Filtro inválido', 'É necessário ao menos um tipo de filtro, revise as informações');
      return;
    }

    this.$refs.relatorioObserver.validate().then((valid: boolean) => {
      if (valid) {
        this.loading = true;
        ContabilOrcamentoFrotaService.relatorioFaturamento(this.filtro, tipo)
          .then((res) => {
            let fileURL = window.URL.createObjectURL(new Blob([res.data]));

            let fileLink = document.createElement("a");

            fileLink.href = fileURL;

            fileLink.setAttribute(
              "download",
              `relatorio_faturamento_frota.${tipo.toLowerCase() === "excel" ? "xls" : "pdf"
              }`
            );

            document.body.appendChild(fileLink);

            fileLink.click();

            this.loading = false;
          })
          .catch((err) => {
            this.openDialog(false, "Erro", err.message);
            this.loading = false;
          });

        //this.limparformulario();
      }
    });
  }

  public toggleCollapsible(): void {
    this.collapsibleOpened = !this.collapsibleOpened;
  }

  public limparformulario(): void {
    this.filtro = _.cloneDeep(this.filtroInicial);
    this.$refs.relatorioObserver.reset();
  }

  private openDialog(success: boolean, title: string, message: string) {
    this.successDialog = success;
    this.dialogTitle = title;
    this.dialogMessage = message;
    this.showDialog = true;
  }

  public closeDialog(): void {
    this.showDialog = false;
  }

  get btnColor() {
    return this.successDialog ? "#00CD96" : "primary";
  }

  get btnText() {
    return this.successDialog ? "Ok, entendi" : "Fechar";
  }

  get dialogImg() {
    return this.successDialog ? "success.png" : "info.png";
  }
}
